import React, { FC } from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { MenuItem as MenuItemType } from 'moduleBase/types/Menu';
import { Tab } from 'react-bootstrap';
import app from 'srcJs/App';

type PropsType = {
  faq: MenuItemType[],
  hide: () => void,
}

const FaqContent: FC<PropsType> = ({
  faq,
  hide,
}) => {
  if (!faq) {
    return null;
  }

  const menuItems = faq.map((menuItem) => (
    <li className="menu-panel-section" key={menuItem.label}>
      <MenuItem
        {...menuItem}
        className="menu-panel-link container container-lg-fluid"
        onClick={() => {
          hide();
        }}
      />
    </li>
  ));

  return (
    <Tab.Pane eventKey="faq">
      <ul className="list-unstyled mb-0">
        <li className="menu-panel-section">
          <span className="menu-panel-link py-12p container container-lg-fluid fs-22">
            {app.tForReact('base_menu', 'FAQ')}
          </span>
        </li>
        {menuItems}
      </ul>
    </Tab.Pane>
  );
};

export { FaqContent };
